/** Demo catalogs removed — icons only for CMS value-service rows. */
export const SERVICE_VIDEO_ITEMS = []

export const SERVICE_SUPPORT_ITEMS = []

export const SERVICE_VALUE_ITEMS = [
  { id: 'va1', icon: 'icon-shangmenfuwu' },
  { id: 'va2', icon: 'icon-ruanjianshengji' },
  { id: 'va3', icon: 'icon-peijiangoumai' },
  { id: 'va4', icon: 'icon-shouhouzhichi' },
  { id: 'va5', icon: 'icon-shouqianzixun' },
  { id: 'va6', icon: 'icon-xiazai' }
]
